<template>
  <div class="give-integral">
    <div class="page_title">
      赠送积分
    </div>
    <div style="padding:20px">
      <div class="container">
        <el-tabs v-model="activeName">
          <el-tab-pane label="赠送积分"
                       name="1"
                       :disabled="
                module_id_array[0] ? !module_id_array.includes('1350') : false
              "></el-tab-pane>
          <el-tab-pane label="赠送记录"
                       name="2"
                       :disabled="
                module_id_array[0] ? !module_id_array.includes('1348') : false
              "></el-tab-pane>
          <component :is="currentComponent" />
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import GiveIntegral from './GiveIntegral.vue';
import GiveRecord from './GiveRecord.vue';
export default {
  data() {
    return {
      activeName: '1',
      info: {}
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    currentComponent() {
      switch (this.activeName) {
        case '1':
          return GiveIntegral;
        case '2':
          return GiveRecord;
        default:
          return GiveIntegral;
      }
    }
  },
  created() {},
  methods: {
    back() {
      history.back();
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background: #fff;
  min-height: calc(100vh - 140px);
}
</style>